module.exports = __webpack_public_path__ + "static/assets/0f431f212115f8db3704038ea01ea09e.png";